<template>
  <div>
    <div style="width: 100%;height: 30px;background-color: #e3e3e3;display: flex;font-size: 13px">
      <div style="margin: auto 0;color: #595a5a;padding-left: 20px"><span>当前位置：</span></div>
      <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: auto 0;font-size: 13px">
        <el-breadcrumb-item v-for="(item,index) in $route.meta.position" :key="index">
          {{ item }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="form-search" style="margin-top: 20px">
      <el-form :model="form" ref="form" class="form">
        <div style="padding: 10px">
          <el-form-item label="状态:" class="init-line-height">
            <el-radio-group v-model="form.state" class="hide_input" @change="getList">
              <el-radio style="margin: 3px 8px" label="all">全部</el-radio>
              <el-radio style="margin: 3px 8px" v-for="(item,index) in dpList" :label="index">{{ item }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="采购类型:" class="init-line-height">
            <el-radio-group v-model="form.cgType" class="hide_input" @change="getList">
              <el-radio style="margin: 3px 8px" label="all">全部</el-radio>
              <el-radio style="margin: 3px 8px" v-for="(item,index) in dpList1" :label="index">{{ item }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="物流信息:" class="init-line-height">
            <el-radio-group v-model="form.wlxx" class="hide_input" @change="getList">
              <el-radio style="margin: 3px 8px" label="all">全部</el-radio>
              <el-radio style="margin: 3px 8px" v-for="(item,index) in dpList2" :label="index">{{ item }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <div style="border-top: 1px solid #F1E6E6;margin-top:10px;padding-top: 10px;padding-right: 25px;">
            <div class="ord-div-input">
              <el-form-item label="采购单号:" class="normal-input">
                <el-input size="small" v-model="form.procurementNo" placeholder="多个采购单号用逗号隔开"></el-input>
              </el-form-item>
              <el-form-item label="供应商:" class="normal-input">
                <el-input size="small" v-model="form.supplierName" placeholder="请输入供应商名称，多个供应商用逗号隔开"></el-input>
              </el-form-item>
              <el-form-item label="本地SKU:" class="normal-input">
                <el-input size="small" v-model="form.localSKU" placeholder="请输入本地SKU，多个本地SKU用逗号隔开"></el-input>
              </el-form-item>
            </div>
            <div class="ord-div-input">
              <el-form-item label="产品名称:" class="normal-input">
                <el-input size="small" v-model="form.cpName"></el-input>
              </el-form-item>
              <el-form-item label="1688订单号:" class="normal-input">
                <el-input size="small" v-model="form.orderNo"></el-input>
              </el-form-item>
              <el-form-item label="运单号:" class="normal-input">
                <el-input size="small" v-model="form.ydNo"></el-input>
              </el-form-item>
            </div>
            <div class="order-form-sear-btn">
              <el-button size="small" @click="resetForm">重置</el-button>
              <el-button size="small" type="primary" @click="search">搜索</el-button>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <!-- @command="batchHandle"-->
    <div style="width: 100%;margin-top: 20px;">
      <el-button type="success" size="small" @click="dialogVisible=true" style="width: 90px">导出</el-button>
    </div>
    <!--新建-->
    <div class="form-search" style="margin-top: 5px">
      <el-table
          :data="orderData"
          style="width: 100%"
          :header-cell-style="{background:'#eef1f6',color:'#595a5a'}">
        <el-table-column
            prop="spxx"
            label="商品信息">
        </el-table-column>
        <el-table-column
            prop="totalAmount"
            label="付款金额">
        </el-table-column>
        <el-table-column
            prop="1688Account"
            label="1688订单号">
        </el-table-column>
        <el-table-column
            prop="trackNo"
            label="运单号">
        </el-table-column>
        <el-table-column
            prop="opeTime"
            label="时间">
        </el-table-column>
        <el-table-column
            prop="puchStatus"
            label="状态">
        </el-table-column>
        <el-table-column prop="handel" label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="passBtn">通过审核</el-button>
            </br>
            <el-button type="text" size="mini" style="margin-top: 2px" @click="rejectBtn">驳回审核
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
          v-show="total>0"
          :total="total"
          :page.sync="form.pageNum"
          :limit.sync="form.pageSize"
          @pagination="getList"
      />
    </div>
  </div>
</template>

<script>

import {getProcurementList} from "@/api/procurement/all"

export default {
  name: "CollectionBox",
  data() {
    return {
      total: 0,
      dpList: ["待提交", "待审核", "待到货", "已完成"],
      dpList1: ["1688采购", "手工采购"],
      dpList2: ["有运单号", "无运单号"],
      orderData: [],
      spanArr: [],
      form: {
        state: 'all',
        cgType: 'all',
        wlxx: 'all'
      },
    }
  },
  created() {
    this.getList();
  },
  methods: {
    resetForm: function () {
      this.form.procurementNo = [];
      this.form.supplierName = [];
      this.form.localSKU = [];
      this.form.cpName = [];
      this.form.orderNo = [];
      this.form.ydNo = [];
    },
    search: function () {
      this.getList();
    },
    passBtn: function () {
      alert("通过");
    },
    rejectBtn: function () {
      alert("驳回");
    },
    //获取订单列表数据
    getList() {
      getProcurementList(this.form).then(res => {
        this.total = res.total;
        this.orderData = res.rows;
      })
    }
  }
}
</script>

<style>
.init-line-height {
  margin-top: 10px !important;
}
.form-search{
  padding: 5px;
  background-color: #fff;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: .2s;
}
.form-search:hover {
  box-shadow: 0 0 8px 0 rgba(190, 198, 219, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
</style>
